/* jshint esversion: 6, -W097 */
/* globals module */
'use strict';

/**
 * Creates an product card rebate tag instance
 *
 * @module enervee_utils.product_card
 */
function productCardRebateTagDirective() {
    return {
        restrict: 'E',
        scope: {
            product: '=',
        },
        bindToController: true,
        controller: productCardRebateTagController,
        controllerAs: 'vm',
        template: require('./rebateTagView.html')
    };
}

productCardRebateTagController.$inject = [
    '$scope',
    'AnalyticsService',
    'CmsContentService',
    'ProductCardService',
    'RebatesService'
];
function productCardRebateTagController(
    $scope,
    AnalyticsService,
    CmsContentService,
    ProductCardService,
    RebatesService
) {
    this.$onInit = () => {
        const vm = this;
        vm.showRebateTag = false;

        //some categories need "up to" in rebates
        CmsContentService.getMarketPlaceText('product_card:upto_rebate_tag_text', {}, vm.product.category_id).then(function (text) {
            vm.upToRebateText = text;
        });

        $scope.$watchGroup(['vm.product.rebates', 'vm.product.incentives', 'vm.product.checkoutInfo'], function () {
            if (vm.product.rebates !== undefined || vm.product.incentives !== undefined) {
                // set rebates
                vm.product.rebates = vm.product.rebates || [];
                checkShowRebateTag(vm.product.rebates, vm.product.incentives);
                if (vm.showRebateTag) {
                    RebatesService.getRebateTagText(vm.product).then(function (text) {
                        if (!vm.product.rebates.length) {
                            vm.product.noRebateText = text;
                        } else {
                            vm.product.rebateTagText = text;
                        }
                    });
                }
                ProductCardService.getCardAriaText(vm.product);
            }
        });

        function checkShowRebateTag(rebates, incentives) {
            if ((angular.isArray(rebates) && rebates.length > 0) ||
                (angular.isArray(incentives) && incentives.length > 0) ||
                vm.product.category.is_rebatable) {
                vm.showRebateTag = true;
            } else {
                vm.showRebateTag = false;
            }
        }

        /**
         * When the user changes their chosen utility, check if we
         * should still show rebates.
         */
        RebatesService.onUtilityChanged(function () {
            checkShowRebateTag(vm.product.rebates, vm.product.incentives);
        });
    }
}

module.exports = productCardRebateTagDirective;
